import React from "react";
import { Link } from "react-router-dom";

// --- contact images ---
import callImg from "../../images/contact/contact-card-call.webp";
import whatsappImg from "../../images/contact/contact-card-whatsapp.webp";
import emailImg from "../../images/contact/contact-card-email.webp";
import visitImg from "../../images/contact/contact-card-visit.webp";

// --- arrow icons ---
import arrowWhite from "../../images/icon/rotate-arrow-white02.svg";
import arrowBlack from "../../images/icon/rotate-arrow-black03.svg";

// ---- contact items data ----
const contactData = [
  {
    label: "Call Us",
    line1: "+91 89292 22212",
    line2: "Mon–Sat, 10 AM – 7 PM IST",
    img: callImg,
    href: "tel:+918929222212",
    btnText: "CALL NOW",
  },
  {
    label: "WhatsApp Us",
    line1: "+91 89292 22212",
    line2: "Chat with us on WhatsApp",
    img: whatsappImg,
    // wa.me opens the WhatsApp app on mobile and WhatsApp Web on desktop.
    href: "https://wa.me/918929222212",
    btnText: "CHAT ON WHATSAPP",
    external: true,
  },
  {
    label: "Email Us",
    line1: "hello@axoix.com",
    line2: "We reply within 24 hours",
    img: emailImg,
    href: "mailto:hello@axoix.com",
    btnText: "SEND EMAIL",
  },
  {
    label: "Visit Us",
    line1: "B-59, Second Floor, Block-B, Rama Park Road",
    line2: "Uttam Nagar, New Delhi - 110059",
    img: visitImg,
    href: "https://www.google.com/maps/dir//''/data=!4m7!4m6!1m1!4e2!1m2!1m1!1s0x390d05125146eecd:0xe1e9771496b7e3b5!3e0?g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAMYASAF",
    btnText: "GET DIRECTIONS",
    external: true,
  },
];

// ---- custom scoped styles for uniform contact cards ----
const contactCardStyles = `
  .contact-card-uniform {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .contact-card-uniform .xb-item--inner {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .contact-card-uniform .xb-item--holder {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .contact-card-uniform .xb-item--content-wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 80px;
    margin: 5px 0 25px;
  }
  .contact-card-uniform .xb-item--contact_primary {
    font-size: 17px;
    font-weight: 600;
    letter-spacing: -0.02em;
    color: var(--color-white);
    font-family: var(--font-heading);
    line-height: 1.35;
    word-break: break-word;
  }
  .contact-card-uniform .xb-item--contact_secondary {
    font-size: 13.5px;
    letter-spacing: -0.01em;
    color: rgba(255, 255, 255, 0.72);
    margin-top: 6px;
    line-height: 1.4;
    display: block;
  }
  .contact-card-uniform .thm-btn.form-btn {
    margin-top: auto;
    width: 100%;
    max-width: 210px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const ContactInfoSection: React.FC = () => {
  return (
    <section className="contact pb-150">
      <style>{contactCardStyles}</style>
      <div className="container">
        <div className="row mt-none-30">
          {/* 4 cards (Call / WhatsApp / Email / Visit) — 4-up on desktop so the
              last one isn't orphaned on its own row, 2-up on tablet. */}
          {contactData.map((item, index) => (
            <div className="col-lg-3 col-md-6 mt-30 d-flex" key={index}>
              <div className="xb-contact-items img-hove-effect xb-border contact-card-uniform w-100">
                <div className="xb-item--inner">

                  {/* Multiple hover images */}
                  <div className="xb-img">
                    <Link to="/contact"><img src={item.img} alt={item.label} /></Link>
                    <Link to="/contact"><img src={item.img} alt={item.label} /></Link>
                    <Link to="/contact"><img src={item.img} alt={item.label} /></Link>
                    <Link to="/contact"><img src={item.img} alt={item.label} /></Link>
                  </div>

                  {/* Content */}
                  <div className="xb-item--holder">
                    <p className="xb-item--location">{item.label}</p>
                    <div className="xb-item--content-wrap">
                      <span className="xb-item--contact_primary">{item.line1}</span>
                      <span className="xb-item--contact_secondary">{item.line2}</span>
                    </div>

                    <a
                      href={item.href}
                      className="thm-btn form-btn"
                      {...(item.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      {item.btnText}
                      <span className="xb-icon">
                        <img src={arrowWhite} alt="icon" />
                        <img src={arrowBlack} alt="icon" />
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactInfoSection;
